<template>
  <div class="loading-mask" @click="click">
    <b-spinner label="Spinning"></b-spinner>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue';

export default {
  name: 'LoadingMask',
  components: {
    BSpinner,
  },
  methods: {
    click() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.loading-mask > span {
  color: #595959 !important;
}
</style>
